// projects-routing.module.ts

import { NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';
import { StoryComponent } from './story/story.component';
import { TestComponent} from './test/test.component';
import { ConfigurationComponent } from './configuration/configuration.component';
import { SessionManagerComponent } from './session-manager/session-manager.component';
import { KnowledgeBaseComponent } from './knowledge-base/knowledge-base.component';
import {AdminGuard} from '../../admin/admin-guard.service';


const routes: Routes = [
  // Session Manager
  {path: 'sessions/:project_id', component: SessionManagerComponent},
  {
    path: 'sessions',
    component: SessionManagerComponent,
    data: { title: 'Session Manager' }
  },

  // Knowledge Base
  {path: 'knowledge/:project_id', component: KnowledgeBaseComponent},
  {
    path: 'knowledge',
    component: KnowledgeBaseComponent,
    data: { title: 'Knowledge Base' }
  },

  // Nuova rotta con session_id.
  {
    path: 'story/:project_id/session/:session_id',
    component: StoryComponent,
    data: { title: 'Scriptor' }
  },
  // Rotta esistente per nuove sessioni
  {
    path: 'story/:project_id',
    component: StoryComponent
  },
  {
    path: 'story',
    component: StoryComponent,
    data: { title: 'Scriptor' }
  },

  // Nuova rotta con session_id.
  {
    path: 'test/:project_id/session/:session_id',
    component: TestComponent,
    data: { title: 'Scriptor' }
  },
  // Rotta esistente per nuove sessioni
  {
    path: 'test/:project_id',
    component: TestComponent
  },
  {
    path: 'test',
    component: TestComponent,
    data: { title: 'Scriptor' }
  },


  // Configuration
  {
    path: 'configuration',
    component: ConfigurationComponent,
    data: { title: 'Configuration' }
  },
  {path: 'configuration/:project_id', component: ConfigurationComponent},

];

@NgModule({
  imports: [RouterModule.forChild(routes)],
  exports: [RouterModule],
})
export class ProjectsRoutingModule { }
